import { apiDelete, apiGet, apiPost, apiPut } from './http'
import { downloadBlobResponse, normalizeBuildingQuery } from './helpers'

const resolveBuildingId = input => {
  if (!input) return null
  if (typeof input === 'number') return input
  if (typeof input !== 'object') return null

  const normalized = normalizeBuildingQuery(input)
  return typeof normalized.buildingId === 'number' ? normalized.buildingId : null
}

export const findAll = async (params = {}) => {
  const buildingId = resolveBuildingId(params)
  if (!buildingId) {
    return {
      ok: false,
      status: 400,
      message: 'Debe indicar el identificador del edificio.',
    }
  }

  return apiGet(`/bankaccount/findall/${buildingId}`, {
    auth: true,
    fallbackMessage: 'Error al obtener las cuentas bancarias.',
  })
}

export const findById = async (id, params = {}) => {
  const buildingId = resolveBuildingId(params)
  if (!buildingId) {
    return {
      ok: false,
      status: 400,
      message: 'Debe indicar el identificador del edificio.',
    }
  }

  const response = await findAll(buildingId)
  if (!response.ok) return response

  const item = (response.data || []).find(account => account.id === id) || null
  return {
    ok: Boolean(item),
    status: item ? 200 : 404,
    data: item,
    message: item ? undefined : 'Cuenta bancaria no encontrada.',
  }
}

export const create = async payload =>
  apiPost('/bankaccount/create', payload, {
    auth: true,
    fallbackMessage: 'Error al crear la cuenta bancaria.',
  })

export const update = async ({ id, ...payload }) =>
  apiPut(
    '/bankaccount/update',
    { id, ...payload },
    {
      auth: true,
      fallbackMessage: 'Error al actualizar la cuenta bancaria.',
    }
  )

export const remove = async id =>
  apiDelete(`/bankaccount/delete/${id}`, {
    auth: true,
    fallbackMessage: 'Error al eliminar la cuenta bancaria.',
  })

export const downloadExcel = async payload => {
  const response = await apiPost('/docs/commonexpenses/xls', payload, {
    auth: true,
    rawResponse: true,
    config: { responseType: 'blob' },
    fallbackMessage: 'Error al descargar el archivo de cuentas bancarias.',
  })

  if (!response || !response.data) return response

  downloadBlobResponse(response, payload.fileName || 'cuentas-bancarias', 'xlsx')
  return { ok: true }
}
